//#region assets/vp-pdp-upsell.ts
/**
* PDP upsell helpers + marker element.
*
* Checked upsell variants are batched with the main product by
* `product-form-component` on submit. This element is a DOM marker only —
* it must not POST /cart/add itself. Horizon wires `on:submit` via a
* document capture listener, which always runs before a form-capture
* listener, so a second add here duplicated the main product.
*/
/**
* @param {ParentNode} root
* @returns {string[]}
*/
function collectSelectedUpsellVariantIds(root) {
	return [...root.querySelectorAll("input[data-vp-upsell-variant-id]:checked:not(:disabled)")].map((input) => String(
		/** @type {HTMLInputElement} */
		input.dataset.vpUpsellVariantId || ""
	)).filter(Boolean);
}
/**
* @param {string} mainId
* @param {number} quantity
* @param {string[]} upsellIds
* @returns {Array<{id: number, quantity: number}>}
*/
function buildPdpUpsellCartItems(mainId, quantity, upsellIds) {
	/** @type {Array<{id: number, quantity: number}>} */
	const items = [{
		id: Number(mainId),
		quantity
	}];
	for (const variantId of upsellIds) {
		if (variantId === mainId) continue;
		items.push({
			id: Number(variantId),
			quantity: 1
		});
	}
	return items;
}
/**
* @param {FormData} formData
* @returns {Record<string, string>}
*/
function cartAttributesFromFormData(formData) {
	/** @type {Record<string, string>} */
	const attributes = {};
	for (const [key, value] of formData.entries()) {
		const match = key.match(/^attributes\[(.+)\]$/);
		if (!match) continue;
		attributes[match[1]] = String(value);
	}
	return attributes;
}
var VpPdpUpsell = class extends HTMLElement {};
if (!customElements.get("vp-pdp-upsell")) customElements.define("vp-pdp-upsell", VpPdpUpsell);
//#endregion
export { buildPdpUpsellCartItems, cartAttributesFromFormData, collectSelectedUpsellVariantIds };
